export const SET_MODAL = 'SET_MODAL'
export const CLEAR_MODAL = 'CLEAR_MODAL'
export const SET_MODAL_TYPE = 'SET_MODAL_TYPE'